import React, {forwardRef, useEffect, useRef, memo} from 'react';
import UserTreeSelect from '../UserSelect/UserTreeSelect.jsx';
import UserSelect from '../UserSelect/UserSelect.jsx';

export const valueFormatter = ({value}) => {
  return value?.label || '';
};

const UserChoiceCellEditor = memo(forwardRef((
  {
    column,
    value,
    onValueChange,
    eventKey,
    options,
    creatable,
    addCreatableOption,
    creatableOptions,
    ...rest
  }, ref
) => {
  const refContainer = useRef(null);

  useEffect(() => {
    refContainer.current.focus();
  }, []);

  const handleChange = (selected) => {
    onValueChange(selected);
    rest.stopEditing();
  };

  const useOrganisationTreePicker =
    column.colDef?.cellRendererParams?.original?.additional_settings['use_organisation_tree_picker'];

  return (
    <div ref={refContainer} style={{display: 'inline-block', minWidth: 200, maxWidth: 400}}>
      {useOrganisationTreePicker ?
        <UserTreeSelect
          value={value?.value}
          label={value?.label}
          placeholder={''}
          onChange={(val) => handleChange(val)}
          styles={{
            option: (base) => ({
              ...base,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }),
            menu: (base) => ({
              ...base,
              width: 'auto',
              minWidth: '100%',
              maxWidth: 400,
            }),
          }}
          autoFocus
          openMenuOnFocus
        />
        :
        <UserSelect
          value={value?.value}
          label={value?.label}
          placeholder={''}
          onChange={(val) => handleChange(val)}
        />
      }
    </div>
  )
}));

export default UserChoiceCellEditor;
